const getAuthor = content =>
  content?.author?.alias ||
  `${content?.author.givenName} ${content?.author.familyName}`

export { getAuthor }
